import state from './_State'
import mutations from './_Mutations'
import getters from './_Getters'
import actions from './_Actions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
